import React, { useState, useEffect } from 'react'

import { createBrowserHistory } from 'history'

import { IonReactRouter } from '@ionic/react-router'
import { IonRouterOutlet, IonSplitPane } from '@ionic/react'
import {
  Redirect, Route, Switch,
} from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../stylesheets/Tasks.css'

import { useAuth } from '../hooks/useAuth.tsx'

import MenuDrawer from './MenuDrawer'
import Login from '../pages/Login'
import Register from '../pages/Register'
import Recovery from '../pages/RecoverPassword'
import ResetPassword from '../pages/ResetPassword'

import JourneysApp2 from '../pages/JourneysApp2'
import NotificationsList from '../pages/Notifications'
import JourneysMobile from '../pages/mobile/JourneysMobile'

import InsightsApp from '../pages/InsightApp'
import TasksApp from '../pages/TasksApp'
import Testing from '../pages/Testing'
import Configuration from '../pages/Configuration'
import Dashboard from '../pages/Dashboard'
import ConsultantsApp from '../pages/ConsultantsApp'
import Settings from '../pages/Settings'
import Loading from '../pages/Loading'
import Activate from '../pages/Activate'
import ChooseDomain from '../pages/ChooseDomain'
import { useWorkspace } from '../hooks/useWorkspace'
import useApi from '../hooks/testHooks'
import { useGeolocation } from '../hooks/useGeolocation'
import ProjectsAppV2 from '../pages/ProjectsAppV2'

import MessagingApp from '../pages/MessagingApp'

import Forms from '../pages/Forms'

import AnalyticsDashboard from '../pages/AnalyticsDashboard'
import { useNotification } from '../hooks/useNotification'
import { useSafetyCheckPopup } from '../hooks/safety-checks/useSafetyCheckPopup'

import { useSecCondPopup } from '../hooks/safety-checks/useSecCondPopup'

import HelpSoon from './helpcenter/HelpSoon'
import HelpCenter from './helpcenter/Home'
import InsightsHelp from './helpcenter/InsightsHelp/InsightsHelp'
import JourneysHelp from './helpcenter/JourneysHelp/JourneysHelp'
import TasksHelp from './helpcenter/TasksHelp/TasksHelp'
import ConsultantHelp from './helpcenter/ConsultantHelp/ConsultantHelp'
import RisksHelp from './helpcenter/RisksHelp/RisksHelp'
import ProjectsHelp from './helpcenter/ProjectsHelp/ProjectsHelp'

import InsightsUseMap from './helpcenter/InsightsHelp/InsightsUseMap'
import InsightsAdd from './helpcenter/InsightsHelp/InsightsAdd'
import InsightsViews from './helpcenter/InsightsHelp/InsightsViews'
import InsightsAddIncident from './helpcenter/InsightsHelp/InsightsAddIncident'
import InsightsAlerts from './helpcenter/InsightsHelp/InsightsAlerts'

import TasksAdd from './helpcenter/TasksHelp/TasksAdd'
import TasksEdit from './helpcenter/TasksHelp/TasksEdit'
import TasksSort from './helpcenter/TasksHelp/TasksSort'
import TasksUse from './helpcenter/TasksHelp/TasksUse'
import SafetyCheckPopup from './popups/SafetyCheckPopup'
import SecPopupHandler from './popups/SecPopupHandler'

import RiskAssessmentsApp from '../pages/RiskAssessmentsApp'
import AnalystApp from '../pages/AnalystApp'

import ReportsApp from '../pages/ReportsApp'
import IncidentManagementApp from '../pages/IncidentManagementApp'
import InsightsDashboard from './dashboard/insights/InsightsDashboard'

import WeeklyReportHandler from './popups/WeeklyReportHandler'
import AndroidPopup from './popups/AndroidAppPopup'
import TrackerPopupHandler from './popups/TrackerPopupHandler'
import TestingMap from '../pages/TestingMap'
import FirstPassword from '../pages/FirstPassword'
import VerifySMS from '../pages/VerifySMS'
import FSitRepFormPopup from './popups/FSitRepFormPopup'
import TerrainMappingApp from '../pages/TerrainMappingApp'
import EngagementApp from '../pages/EngagementApp'
import RiskAssessmentsAppV2 from '../pages/RiskAssessmentsAppV2'

// history
const history = createBrowserHistory()

const Router = () => {
  const [loading, setLoading] = useState(true)
  const [domains, setDomains] = useState([])
  const auth = useAuth()
  const workspace = useWorkspace()
  const geolocation = useGeolocation()
  const [displayPopup] = useSafetyCheckPopup()
  const [displaySecPopup] = useSecCondPopup()
  const apiHook = useApi()
  const notification = useNotification()

  /* Detect changes in user session to refresh notifications  */
  useEffect(() => {
    if (auth.user) {
      notification.fetchNotifications(auth.user.user_id, displayPopup, displaySecPopup)
    }
  }, [auth.user])

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const redirectToApp = queryParams.get('sms')

    if (redirectToApp === 'redirect') {
      const isAndroid = /Android/i.test(window.navigator.userAgent)
      if (isAndroid) {
        const appIntent = 'intent://sherpa#Intent;scheme=sherpaapp;package=com.sherpaandroid;end'
        window.location = appIntent
      }
      console.log('redirectToApp')
    }
  })

  /* eslint-disable */
  const isMobile = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check
  }
  /* eslint-enable */

  const DomainSpecificRoute = ({ children }) => {
    // eslint-disable-next-line no-undef
    const cookieWs = workspace.workspace || JSON.parse(localStorage.getItem('current-workspace'))

    const renderIfSelected = () => {
      /** Check if the workspace stored in cookies is part of the fetched workspaces */
      if (cookieWs && domains.find((val) => val.id === cookieWs.id)) return children

      return (
        <Redirect to={{
          pathname: '/workspaces',
        }}
        />
      )
    }

    return (
      <Route
        render={renderIfSelected}
      />
    )
  }

  const pushNewDomain = (domain) => {
    setDomains([...domains, domain])
  }

  const updateDomain = (id, properties) => {
    const copy = domains.slice()
    const index = domains.findIndex((domain) => domain.id === id)
    const oldDomain = copy.splice(index, 1)[0]

    copy.push({ ...oldDomain, ...properties })
    setDomains(copy)
    workspace.setDomain({
      ...workspace.workspace,
      ...properties,
    })
  }

  useEffect(async () => {
    try {
      const profile = auth.fetchProfile()
      if (!profile) return

      const [retrievedDomains] = await Promise.all([apiHook.getRolesbyUser(-1)])

      auth.setResetPassword(retrievedDomains.reset_password)
      auth.setVerifySms(retrievedDomains.need_to_verify_sms)
      auth.setCouldVerifySms(retrievedDomains.could_verify_sms)

      workspace.setDomains(retrievedDomains)
      const current = workspace.fetchDomain()
      notification.fetchNotifications(profile.user_id, null, displaySecPopup)
      notification.countNotifications(profile.user_id)

      window.mobileCheck = function () {
        /* eslint-disable  */
        let check = false
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true }(navigator.userAgent || navigator.vendor || window.opera))
        /* eslint-enable */
        return check
      }

      console.log(retrievedDomains.roledata)
      if (current) workspace.setDomain(retrievedDomains.roledata.find((domain) => domain.id === current.id))
      setDomains(retrievedDomains.roledata)
    } catch {
      auth.setUser(null)
    } finally {
      setLoading(false)
      // eslint-disable-next-line no-undef
      if (navigator.geolocation) {
        // eslint-disable-next-line no-undef
        navigator.geolocation.getCurrentPosition(geolocation.setGeodata)
      }
    }
  }, [])

  if (loading) {
    return <Loading />
  }

  return (
    <IonReactRouter history={history}>
      <SafetyCheckPopup />
      <SecPopupHandler />
      <TrackerPopupHandler />
      <FSitRepFormPopup />
      <AndroidPopup />
      <IonSplitPane contentId='main' when='lg'>
        <MenuDrawer workspaces={domains} />
        <IonRouterOutlet id='main'>
          <Switch>
            <Route path='/login' exact>
              <Login setDomains={(domainsData) => {
                setDomains(domainsData)
                workspace.setDomains(domainsData)
              }}
              />
            </Route>
            <Route path='/activate' exact>
              <Activate />
            </Route>
            <Route path='/recovery' exact>
              <Recovery />
            </Route>
            <Route path='/recoveryreset' exact>
              <ResetPassword />
            </Route>
            <PrivateRoute path='/verifysms' exact>
              <VerifySMS />
            </PrivateRoute>
            <Route path='/register' exact>
              <Register />
            </Route>
            <Route path='/notifications' exact>
              <NotificationsList />
            </Route>
            <PrivateRoute path='/configuration' exact>
              <Configuration />
            </PrivateRoute>
            <PrivateRoute path='/may_your_breasts_be_like_clusters_of_grapes_on_the_vine' exact>
              <Testing />
            </PrivateRoute>
            <PrivateRoute path='/analyticsdash' exact>
              <AnalyticsDashboard />
            </PrivateRoute>
            <PrivateRoute path='/resetpassword' exact>
              <FirstPassword />
            </PrivateRoute>
            <PrivateRoute path='/home' exact>
              <DomainSpecificRoute>
                <Dashboard />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/dashboard-app' exact>
              <DomainSpecificRoute>
                <InsightsDashboard />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/insights' exact>
              <DomainSpecificRoute>
                <InsightsApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/journeys' exact>
              <DomainSpecificRoute>
                {
                  (isMobile()) ? (
                    <JourneysMobile />
                  ) : (
                    <JourneysApp2 />
                  )
                }
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/tasks' exact>
              <DomainSpecificRoute>
                <TasksApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/consultants' exact>
              <DomainSpecificRoute>
                <ConsultantsApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/settings' exact>
              <DomainSpecificRoute>
                <Settings
                  addDomain={pushNewDomain}
                  updateDomain={updateDomain}
                />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/projects' exact>
              <DomainSpecificRoute>
                <ProjectsAppV2 />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/analyst' exact>
              <DomainSpecificRoute>
                <AnalystApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/incidents' exact>
              <DomainSpecificRoute>
                <IncidentManagementApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/engagement' exact>
              <DomainSpecificRoute>
                <EngagementApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/forms' exact>
              <DomainSpecificRoute>
                <Forms />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/reports' exact>
              <DomainSpecificRoute>
                <ReportsApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/chats' exact>
              <DomainSpecificRoute>
                <MessagingApp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/crisis' exact>
              <DomainSpecificRoute>
                <IncidentManagementApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter' exact>
              <DomainSpecificRoute>
                <HelpCenter />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-helpsoon' exact>
              <DomainSpecificRoute>
                <HelpSoon />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-insights' exact>
              <DomainSpecificRoute>
                <InsightsHelp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-projects' exact>
              <DomainSpecificRoute>
                <ProjectsHelp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-journeys' exact>
              <DomainSpecificRoute>
                <JourneysHelp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-tasks' exact>
              <DomainSpecificRoute>
                <TasksHelp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-tasks-use' exact>
              <DomainSpecificRoute>
                <TasksUse />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-tasks-addtask' exact>
              <DomainSpecificRoute>
                <TasksAdd />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-tasks-sort' exact>
              <DomainSpecificRoute>
                <TasksSort />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-tasks-edit' exact>
              <DomainSpecificRoute>
                <TasksEdit />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-consultant' exact>
              <DomainSpecificRoute>
                <ConsultantHelp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-risks' exact>
              <DomainSpecificRoute>
                <RisksHelp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/communities' exact>
              <DomainSpecificRoute>
                <TerrainMappingApp />
              </DomainSpecificRoute>
            </PrivateRoute>

            <PrivateRoute path='/helpcenter-insights-usemap' exact>
              <DomainSpecificRoute>
                <InsightsUseMap />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-insights-addinsight' exact>
              <DomainSpecificRoute>
                <InsightsAdd />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-insights-addincident' exact>
              <DomainSpecificRoute>
                <InsightsAddIncident />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-insights-views' exact>
              <DomainSpecificRoute>
                <InsightsViews />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/helpcenter-insights-alertstates' exact>
              <DomainSpecificRoute>
                <InsightsAlerts />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/risks'>
              <DomainSpecificRoute>
                <RiskAssessmentsApp />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/risksbeta'>
              <DomainSpecificRoute>
                <RiskAssessmentsAppV2 />
              </DomainSpecificRoute>
            </PrivateRoute>
            <PrivateRoute path='/' exact>
              <Redirect to='/home' />
            </PrivateRoute>
            <PrivateRoute path='/workspaces' exact>
              <ChooseDomain workspaces={domains} addDomain={pushNewDomain} setDomains={setDomains} />
            </PrivateRoute>
            <PrivateRoute path='/efficiencytesting' exact>
              <TestingMap />
            </PrivateRoute>
          </Switch>
        </IonRouterOutlet>
      </IonSplitPane>
    </IonReactRouter>
  )
}

const PrivateRoute = ({ children, ...rest }) => {
  const auth = useAuth()

  const renderIfAuthenticated = ({ location }) => {
    if (auth.resetPassword && location.pathname !== '/resetpassword') {
      return (
        <Redirect to={{
          pathname: '/resetpassword'
        }} />
      )
    }

    if (auth.verifySms && location.pathname !== '/verifysms' && location.pathname !== '/resetpassword') {
      return (
        <Redirect to={{
          pathname: '/verifysms'
        }} />
      )
    }

    if (auth.user) {
      return children
    }

    return (
      <Redirect to={{
        pathname: '/login',
        state: { from: location },
      }}
      />
    )
  }

  return (
    <Route
      {...rest}
      render={renderIfAuthenticated}
    />
  )
}

export const API_ROOT = 'http://localhost:3000'
export const API_WS_ROOT = 'ws://localhost:3000/cable'
export const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
}

export default Router
